import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n";

export default function NotFound() {
  const { lang } = useLang();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = lang === "it" ? "Pagina non trovata | BOXLY" : "Page not found | BOXLY";
  }, [lang]);
  const it = lang === "it";
  return (
    <main className="flex min-h-screen items-center bg-white pb-24 pt-28 sm:pt-32" data-testid="not-found-page">
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-8">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-electric-blue">404</p>
        <h1 className="mt-4 font-display text-5xl font-black leading-[0.95] text-ink sm:text-7xl">
          {it ? "Pagina non trovata." : "Page not found."}
        </h1>
        <p className="mx-auto mt-6 max-w-md font-body text-lg text-ink/70">
          {it
            ? "La pagina che stai cercando non esiste o è stata spostata."
            : "The page you're looking for doesn't exist or has been moved."}
        </p>
        <Link to="/" className="group mt-10 inline-flex items-center gap-2 rounded-md bg-electric-blue px-7 py-4 font-grotesk text-base font-bold text-white transition-colors duration-300 hover:bg-ink hover:text-lime-accent" data-testid="not-found-cta">
          {it ? "Torna alla home" : "Back to home"}
          <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </Link>
      </div>
    </main>
  );
}
